import mixpanel from "mixpanel-browser"

import { AnalyticsEvent } from "@/services/analytics/events"

const token = import.meta.env.VITE_MIXPANEL_TOKEN

if (token) {
  mixpanel.init(token, {
    ignore_dnt: true,
    track_pageview: "url-with-path-and-query-string",
    api_host: "https://api-eu.mixpanel.com",
  })
}

export const MixpanelTracking = {
  identifyUser(user: { id: string; email: string; full_name: string }) {
    if (!token) return
    mixpanel.identify(user.id)
    mixpanel.people.set({
      $name: user.full_name,
      $email: user.email,
    })
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(name: AnalyticsEvent, data: Record<string, any> = {}) {
    if (!token) return
    mixpanel.track(name, data)
  },
  reset() {
    if (!token) return
    mixpanel.reset()
  },
}
